import axios from 'axios'

const state = {
  errors: [],
  errors_status: false
}

const getters = {
  getErrors(state) {
    return state.errors
  },
  getShowErrors(state, data) {
    return state.errors_status
  }
}

const mutations = {
  setErrors(state, data) {
    state.errors = data.errors
  },
  setShowErrors(state, data) {
    state.errors_status = data
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
